export const name = 'tpaPostMessageAspect'
